// Pure, read-only routing decision for the Novel / Story "Continue Writing" action.
// Book Structure owns chapter/scene assignment; this function does not mutate it.
const clean = (value) => value == null ? "" : String(value).trim();

function sceneId(scene) {
  return clean(scene?._id || scene?.id || scene?.sceneId);
}

function approvedCanonScenes(story) {
  return (Array.isArray(story?.scenes) ? story.scenes : [])
    .filter((scene) =>
      clean(scene?.type).toLowerCase() === "canon" &&
      clean(scene?.status).toLowerCase() === "approved" &&
      Boolean(sceneId(scene))
    )
    .slice()
    .sort((a, b) => {
      const aNumber = Number(a?.sceneNumber);
      const bNumber = Number(b?.sceneNumber);
      if (Number.isFinite(aNumber) && Number.isFinite(bNumber) &&
          aNumber !== bNumber) return aNumber - bNumber;
      return new Date(a?.createdAt || 0).getTime() -
        new Date(b?.createdAt || 0).getTime();
    });
}

export function selectNovelContinueWritingTargetV1(story) {
  const chapters = Array.isArray(story?.chapters) ? story.chapters : [];
  const canonScenes = approvedCanonScenes(story);
  const savedIds = new Set(canonScenes.map(sceneId));

  // Keep existing chapter-first behavior: newest nonempty saved chapter,
  // then its last linked approved Canon scene. No reassignment is inferred.
  for (let i = chapters.length - 1; i >= 0; i -= 1) {
    const chapterId = clean(chapters[i]?.id);
    if (!chapterId) continue;
    const linked = Array.isArray(chapters[i]?.sceneIds)
      ? chapters[i].sceneIds
      : [];
    const lastSceneId = [...linked]
      .reverse()
      .map(clean)
      .find((id) => savedIds.has(id));
    if (lastSceneId) return { chapterId, sceneId: lastSceneId };
  }

  // Older books may have Canon scenes without saved chapter assignments.
  // Resume the existing scene in Writer Studio without inventing a chapter.
  const latestCanon = canonScenes[canonScenes.length - 1];
  if (latestCanon) return { sceneId: sceneId(latestCanon) };

  // The explicit first scene of an existing empty saved chapter can be new.
  const firstSavedChapterId = chapters.map((chapter) => clean(chapter?.id))
    .find(Boolean);
  if (firstSavedChapterId) {
    return { chapterId: firstSavedChapterId, newScene: true };
  }

  // An entirely empty legacy book belongs in Book Workspace for setup.
  // Never create Chapter 1 merely because Continue Writing was clicked.
  return null;
}
